import styled, { css, createGlobalStyle } from 'styled-components'

export const HostStyles = createGlobalStyle`
  :host {
    --availability-padding: 5px 12px;
    --availability-border-radius: var(--border-radius-lg, 20px);

    --availability-available-background-color: var(--color-green, #8fcc40);
    --availability-available-color: var(--color-white, #fff);
    --availability-unavailable-background-color: var(--color-red, #f85454);
    --availability-unavailable-color: var(--color-white, #fff);
  }
`

export const Availability = styled.span`
  padding: var(--availability-padding);

  border-radius: var(--availability-border-radius);

  ${({ available }) => available && css`
    background-color: var(--availability-available-background-color);
    color: var(--availability-available-color);
  `}

  ${({ available }) => !available && css`
    background-color: var(--availability-unavailable-background-color);
    color: var(--availability-unavailable-color);
  `}
`
